<template>
  <el-upload
    class="upload-demo"
    :disabled="disabled"
    :headers="myHeaders"
    :limit='limit'
    :accept="accept"
    :on-success="uploadSuccess"
    :before-upload="beforeUpload"
    :before-remove="beforeRemove"
    :on-remove="removeFile"
    :on-exceed="overSize"
    :auto-upload="autoUpload"
    :show-file-list='showFileList'
    :file-list="fileList"
    :list-type="listType"
    ref="uploader"
    :drag="drag"
    :multiple="multiple"
    @change="filterChange"
    @on-change='filterChange'
    :action="avatarUploadUrl">
    <template v-if="drag">
      <i class="el-icon-upload"></i>
      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
      <div class="el-upload__tip" slot="tip">{{noticeText}}</div>
    </template>
    <template v-else>
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">{{noticeText}}</div>
    </template>
  </el-upload>
</template>

<script type="text/javascript">
import Operation from "@/request"
export default {
  props: {
    disabled:{
      type:Boolean,
      default:false
    },
    accept:{
      type:String,
      default:''
    },
    limit:{
      type:Number,
      default:1
    },
    uploadPath:{
      type:String,
      required:true
    },
    autoUpload:{
      type:Boolean,
      default:true
    },
    pic:{
      type:String,
      default:''
    },
    noticeText:{
      type:String,
      default:'只能上传jpg/png文件，且不超过500kb'
    },
    drag:{
      type:Boolean,
      default:false
    },
    multiple:{
      type:Boolean,
      default:false
    },
    uploadSize:{
      type:Number
    },
    showFileList:{
      type:Boolean,
      default:true
    },
    listType:{
      type:String,
      default:'picture'
    },
    clearUploadedFile:{
      type:Boolean,
      default:false
    }
  },
  model:{
    prop:'pic',
    event:'change'
  },
  data() {
    return {
      fileList: [],
      avatarUploadUrl:'',
      myHeaders:{}
    }
  },
  created () {
    this.getAvatarUploadUrl()
  },
  methods: {
    //拼接头像上传地址
    getAvatarUploadUrl(){
      let token = Operation.SessionStorage.get('token')
      this.myHeaders= {token: token}
      this.avatarUploadUrl=Operation.Const.ApiUrl+this.uploadPath
    },
    removeFile(file, fileList) {
      this.$emit('removed',file)
    },
    overSize(files, fileList){
      this.$message({
        message: '上传数量超过限制',
        type: 'warning'
      });
    },
    beforeRemove(file, fileList) {
      if (file && file.status==="success") {
          //删除
          return this.$confirm(`确定移除 ${ file.name }？`).then(()=>{
            this.$emit('remove',file)
          })
      }
    },
    beforeUpload(file){
      let fileType=file.name.split('.')
      let length=fileType.length
      let FileTypeFilter=()=>{
        if(this.accept!=''){
          if(this.accept.indexOf(fileType[length-1])!=-1){
            return true
          }else{
            this.$message.error(`上传文件只能是 ${this.accept} 格式!`);
            return false
          }
        }else{
          return true
        }
      }
      let isLtSize=()=>{
        if(this.uploadSize){
          if(file.size / 1024 / 1024 > this.uploadSize){
            this.$message.error(`上传文件大小请不要超过${this.uploadSize}MB!`);
            return false
          }
        }
        return true
      }
      return FileTypeFilter()&&isLtSize()
    },
    uploadSuccess(res,file){
      if(res.succeed || typeof res == 'string'){
        this.$message({
          message: '上传成功',
          type: 'success'
        });
        this.$emit('change',res)
        this.$emit('getFile',{
          res:res,
          file:file
        })
        if(this.clearUploadedFile){
          this.$refs.uploader.clearFiles()
        }
      } else {
        this.$message({
          message: res.msg,
          type: 'error'
        });
        this.$refs.uploader.clearFiles()
      }
    },
    filterChange(){
      console.log("111")
    }
  }
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/upload/clickUpload.vue